import { Link } from "@tanstack/react-router";
import { Sparkles } from "lucide-react";
import logo2026 from "@/assets/mostrando-mexico-logo-2026.png.asset.json";
const brandIcon = "/favicon.svg";

/**
 * Logotipo oficial: ícono + «Mostrando México». Los colores nunca cambian;
 * sobre fotografía las letras van en blanco y «México» en dorado.
 * El lema «Tours · Experiencias» se oculta en celular.
 */
export function BrandLockup({ onPhoto = false, className = "" }: { onPhoto?: boolean; className?: string }) {
  return (
    <Link to="/" aria-label="Mostrando México — inicio" className={`inline-flex min-w-0 items-center gap-2 ${className}`}>
      <img src={logo2026.url} alt="Mostrando México" width={1920} height={656} className="h-9 w-auto max-w-[150px] shrink-0 object-contain sm:max-w-[200px] lg:h-10" loading="eager" decoding="async" />
    </Link>
  );
}

/** Ícono de Maya: el mismo ícono de la marca con borde dorado y distintivo de estrellitas. */
export function MayaMark({ size = 44, className = "" }: { size?: number; className?: string }) {
  return (
    <span className={`relative inline-grid shrink-0 place-items-center rounded-full bg-background ring-2 ring-gold ${className}`} style={{ width: size, height: size }}>
      <img src={brandIcon} alt="" className="h-[78%] w-[78%] object-contain" loading="eager" decoding="async" />
      <span className="absolute -right-1 -top-1 grid h-[42%] w-[42%] place-items-center rounded-full bg-gold text-foreground ring-2 ring-background">
        <Sparkles className="h-[70%] w-[70%]" aria-hidden />
      </span>
    </span>
  );
}
